import React from "react";
import { useSelector } from "react-redux";
import Loader from "./Loader.js";
import PermissionDenied from "./PermissionDenied.js";
import StudentsOnboarding from "./onboarding/StudentsOnboarding";
import StudentsPrincipal from "./principal/StudentsPrincipal";
import StudentsBilling from "./billing/StudentsBilling";

const Classes = () => {
  const state = useSelector((state) => state);

  if (state.auth.isLoading) {
    return <Loader />;
  } else {
    if (state.auth.user.is_onboarding) {
      return <StudentsOnboarding />;
    }
    if (state.auth.user.is_principal) {
      return <StudentsPrincipal />;
    }
    if (state.auth.user.is_billing) {
      return <StudentsBilling />;
    }

    return <PermissionDenied />;
  }
};

export default Classes;
